/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: () => ({
        sashblock: {
            fontSize: {base: '7px', xl: 'xs'},
            lineHeight: {base: '3', xl: '4'},
            fontFamily: 'Lato',
            ml: 0,
            mr: 1,
            fontWeight: 'extrabold',
            borderRadius: 'lg',
            _last: {
                mr: 0
            }
        },
        instock: {
            backgroundColor: '#fab818',
            color: 'woodsmoke',
            marginLeft: '8px',
            px: '2',
            py: '1'
        },
        preorder: {
            backgroundColor: '#2abdbb',
            color: 'textColor',
            marginLeft: '8px',
            px: '2',
            py: '1'
        },
        backorder: {
            backgroundColor: 'textColorInvert',
            outline: '2px solid #000',
            borderRadius: '4px',
            marginLeft: '8px',
            color: 'black',
            px: '2',
            py: '1'
        },
        soldout: {
            backgroundColor: 'black',
            color: 'textColorInvert',
            marginLeft: '8px',
            px: '2',
            py: '1'
        },
        sale: {
            backgroundColor: 'pomegranateBase',
            color: 'textColorInvert',
            position: 'relative',
            borderColor: 'pomegranateBase',
            px: '2',
            py: '1'
        },
        exclusive: {
            backgroundColor: 'orangeBaseColor',
            color: 'white',
            borderColor: 'orangeBaseColor',
            marginBottom: '0',
            padding: '4px 8px 4px 6px',
            fontSize: 'xs',
            lineHeight: '4',
            fontFamily: 'Lato',
            ml: 0,
            mr: 1,
            fontWeight: 'extrabold',
            borderRadius: 'lg'
        },
        comingsoon: {
            backgroundColor: '#51d6d5',
            color: 'black',
            position: 'relative',
            px: '2',
            py: '1'
        },
        limitedStock: {
            backgroundColor: 'textColorInvert',
            color: 'black',
            position: 'relative',
            border: '1px solid black',
            px: '2',
            py: '1'
        }
    }),
    parts: [
        'instock',
        'preorder',
        'backorder',
        'soldout',
        'sale',
        'exclusive',
        'comingsoon',
        'limitedStock'
    ]
}
